import { useQuery } from '@apollo/client';
import { useRouter } from '@application/utils';
import { graphql } from '@gql/gql';
import { CountryCode } from '@gql/graphql';

export const SHELTER_GET_SHELTERS = graphql(`
  query ShelterGetShelters(
    $where: DogShelterWhereInput
    $translationWhere: DogShelterTranslationWhereInput
    $take: Int
  ) {
    findManyDogShelter(where: $where, take: $take) {
      ...ShelterCardInfo
    }
  }
`);

export const useGetShelters = (url: string) => {
  const { language, countryCode } = useRouter();

  const { data, error, loading } = useQuery(SHELTER_GET_SHELTERS, {
    variables: {
      where: {
        translations: { some: { url: { not: { equals: url } } } },
        ...(countryCode !== CountryCode.EU
          ? { address: { is: { country: { equals: countryCode } } } }
          : {}),
      },
      translationWhere: { language: { equals: language } },
      take: 12,
    },
    ssr: false,
  });

  return {
    shelters: data?.findManyDogShelter,
    sheltersError: error,
    sheltersLoading: loading,
  };
};
